module.exports = __webpack_public_path__ + "img/2023102701.eb43425f.webp";